var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4126 4.63184H1.58739C0.710668 4.63184 0 5.34264 0 6.21923V33.7805C0 34.6571 0.710668 35.3679 1.58739 35.3679H38.4127C39.2893 35.3679 40.0001 34.6573 40.0001 33.7805V6.21923C40 5.34264 39.2892 4.63184 38.4126 4.63184ZM14.3406 26.2012L15.7171 21.3817H10.5795L9.20245 26.2012H6.04916L9.59202 13.7986H12.7461L11.2883 18.9014H16.4256L17.8834 13.7986H21.0378L17.4941 26.2012H14.3406ZM33.6703 19.9999C32.6224 23.6673 29.1698 26.2012 25.1835 26.2012H19.9749L22.3157 18.0071H25.469L23.8473 23.6846H26.0973C28.0285 23.6846 29.8357 22.1967 30.458 20.0179C31.0857 17.8206 30.0632 16.3149 28.0611 16.3149H22.7986L23.5175 13.7986H28.8506C32.7485 13.7986 34.7224 16.3149 33.6703 19.9999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHd);
export default __webpack_public_path__ + "static/media/hd.4c8b28d9e0bee6132672e75569a4d6a9.svg";
export { ForwardRef as ReactComponent };